import actionTypes from './actionTypes';

export const fetch = (oId) => ({
  type: actionTypes.FETCH,
  payload: {
    oId,
  },
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const fetched = (order) => ({
  type: actionTypes.FETCHED,
  payload: {
    order,
  },
});

export const failed = () => ({
  type: actionTypes.FAILED,
});

export const updateDistance = (distance) => ({
  type: actionTypes.UPDATE_DISTANCE,
  payload: {
    distance,
  },
});

export const updateDuration = (duration) => ({
  type: actionTypes.UPDATE_DURATION,
  payload: {
    duration,
  },
});

export const updateStatus = (status) => ({
  type: actionTypes.UPDATE_STATUS,
  payload: {
    status,
  },
});

export const updateLocation = (location) => ({
  type: actionTypes.UPDATE_LOCATION,
  payload: {
    location,
  },
});

export const replaceShipments = (shipments) => ({
  type: actionTypes.REPLACE_SHIPMENTS,
  payload: {
    shipments,
  },
});

export const fetchShipmentWaybill = (orderId) => ({
  type: actionTypes.FETCH_SHIPMENT_WAYBILL,
  payload: {
    orderId,
  },
});

export const fetchedShipmentWaybill = (waybillUrl) => ({
  type: actionTypes.FETCHED_SHIPMENT_WAYBILL,
  payload: {
    waybillUrl,
  },
});

export const markLoaded = () => ({
  type: actionTypes.MARK_LOADED,
});

export const requestBulkAddressUpdate = (shipments) => ({
  type: actionTypes.REQUEST_BULK_ADDRESS_UPDATE,
  payload: {
    shipments,
  },
});

export const startRequestBulkAddressUpdate = () => ({
  type: actionTypes.START_REQUEST_BULK_ADDRESS_UPDATE,
});

export const finishRequestBulkAddressUpdate = () => ({
  type: actionTypes.FINISH_REQUEST_BULK_ADDRESS_UPDATE,
});

export const assignOrders = (values) => ({
  type: actionTypes.ASSIGN_ORDERS,
  payload: {
    values,
  },
});

export const assignedOrders = () => ({
  type: actionTypes.ASSIGNED_ORDERS,
  payload: {},
});

export const toggleAssignOrdersScreen = () => ({
  type: actionTypes.TOGGLE_ASSIGN_ORDERS_SCREEN,
  payload: {},
});

export const toggleShopmentInReassign = (shipmentId) => ({
  type: actionTypes.TOGGLE_SHIPMENT_IN_REASSIGN,
  payload: {
    shipmentId,
  },
});

export const generateOTP = (shipmentId) => ({
  type: actionTypes.GENERATE_OTP,
  payload: {
    shipmentId,
  },
});

export const generatedOTP = () => ({
  type: actionTypes.GENERATED_OTP,
  payload: {},
});

export const cancelShipment = (shipmentId) => ({
  type: actionTypes.CANCEL_SHIPMENT,
  payload: {
    shipmentId,
  },
});

export const cancelledShipment = () => ({
  type: actionTypes.CANCELLED_SHIPMENT,
  payload: {},
});
